<template>
    <section class="equipment_section">
        <div class="equipment_box_title">
            <h3 class="characteristics_title text_align_center">
                Подъемно-транспортное оборудование.
            </h3>
            <p class="characteristics_indentation_subtext_box5 equipment_width_subtext text_align_center letter-spacing-1">
                Комплексное оснащение ЛК электрической техникой от JUNGHEINRICH, позволяет справляться с задачами любого уровня.
            </p>
        </div>
        <div class="container_technologies">
            <div class="block_equipment">
                <div class="box_text_equipment">
                    <p class="technologies_text text_white text_align_center height_40px">
                        Узкопроходный<br />
                        штабелер
                    </p>
                    <!-- <p class="characteristics_title_meter text_white text_align_center">
                     EKX514
                    </p> -->
                </div>
                <p class="technologies_text text_white">
                    Предназначен для работы в узкопроходной зоне по индуктивной
                    направляющей, с подъемом кабины оператора на h = 11.5
                    метров.
                </p>
                <div class="box_equipment_hover"></div>
                <img
                    src="@/assets/elements/EKX514.png"
                    class="img_EKX514"
                />
            </div>
            <div class="block_equipment">
                <div class="box_text_equipment">
                    <p class="technologies_text text_white text_align_center height_40px">
                        Ричтрак
                    </p>
                    <!-- <p class="characteristics_title_meter text_white text_align_center">
                        ETV318
                    </p> -->
                </div>
                <p class="technologies_text text_white">
                    Предназначен для обслуживания разных видов стеллажей с min
                    AST = 2,8 м., высота подъёма 11,5 м., стрела оборудована
                    видеофиксацией высоты.
                </p>
                <div class="box_equipment_hover"></div>
                <img
                    src="@/assets/elements/ETV318.png"
                    class="img_EKX514"
                />
            </div>
            <div class="block_equipment">
                <div class="box_text_equipment">
                    <p class="technologies_text text_white text_align_center height_40px">
                        Погрузчик
                    </p>
                    <!-- <p class="characteristics_title_meter text_white text_align_center">
                        EFG215
                    </p> -->
                </div>
                <p class="technologies_text text_white">
                    Предназначен для лёгкого маневрирования в узких проходах и
                    перегруженных складах.
                </p>
                <div class="box_equipment_hover"></div>
                <img
                    src="@/assets/elements/EFG215.png"
                    class="img_EKX514"
                />
            </div>
            <div class="block_equipment">
                <div class="box_text_equipment">
                    <p class="technologies_text text_white text_align_center height_40px">
                        Паллетоперевозчик
                    </p>
                    <!-- <p class="characteristics_title_meter text_white text_align_center">
                        ESE 120K
                    </p> -->
                </div>
                <p class="technologies_text text_white">
                    Предназначен для подбора заказов с первого уровня хранения и быстрой погрузки/разгрузки фур
                </p>
                <div class="box_equipment_hover"></div>
                <img
                    src="@/assets/elements/ESE 120K.png"
                    class="img_EKX514"
                />
            </div>
        </div>
    </section>
</template>

<style scoped>
.box_equipment_hover {
    position: absolute;
    bottom: 0px;
    left: 0px;
    right: 0px;
    height: 17.35rem;
    z-index: 1;
    background: linear-gradient(
        180deg,
        rgba(25, 25, 25, 0),
        rgb(25, 25, 25) 77.404%,
        rgb(25, 25, 25) 100%
    );
    display: flex;
    justify-content: center;
}
.img_EKX514 {

    height: 17.37rem;
    position: absolute;
    bottom: 3.5rem;

    z-index: 0;
    object-fit: cover;
    transition: 0.2s ease;
}
.technologies_text {
    z-index: 2;
}
.block_equipment:hover .img_EKX514{

    bottom: 5rem;
 transition: 0.2s ease;
}
.block_equipment{
    overflow: hidden;
}
.characteristics_title_meter{
    z-index: 1;
}
@media (max-width: 767px) {
    .img_EKX514{
    height: 17.37rem;
    position: absolute;
    bottom: 1.5rem;

    }
    .block_equipment:hover .img_EKX514{
    transform: scale(1);
 transition: 0.2s ease;
}
}
</style>
